// Safe text for `<script type="application/ld+json">`. Pure, no imports, so `node --test` loads it.
// Moved to core from chawk-bazar / ciseco (`helpers/jsonLd.js`), jument (`helpers/productJsonLd.js`) and mahya
// (`helpers/jsonLd.js`, which escaped only `<`): a `</script>` inside a product title or description closed the tag.

// `<`, `>`, `&` and the two JS line separators (U+2028, U+2029). Built from char codes so no raw separator sits in
// this file. JSON allows the \uXXXX form, so the parsed data stays the same.
const UNSAFE_CHARS = new RegExp(`[${[0x3c, 0x3e, 0x26, 0x2028, 0x2029].map((code) => String.fromCharCode(code)).join("")}]`, "g");
const unicode_escape = (char) => `\\u${char.charCodeAt(0).toString(16).padStart(4, "0")}`;

// Drops null / undefined entries of an array (a skipped node would be `null` in the JSON-LD).
export const clean_json_ld = (data) => (Array.isArray(data) ? data.filter((item) => item !== null && item !== undefined) : data);

// True when there is nothing worth printing: null, undefined, `{}` or an array with no real entry.
export const is_empty_json_ld = (data) => {
  const clean = clean_json_ld(data);
  if (clean === null || clean === undefined || clean === "") return true;
  if (Array.isArray(clean)) return clean.length === 0;
  return typeof clean === "object" && Object.keys(clean).length === 0;
};

// chawk-bazar / ciseco / jument / mahya: JSON.stringify plus escaping of `<`, `>`, `&`, U+2028 and U+2029.
// null / undefined give "{}" (as in chawk-bazar / ciseco / jument).
export const json_ld_script_content = (data) => (JSON.stringify(clean_json_ld(data ?? {})) ?? "{}").replace(UNSAFE_CHARS, unicode_escape);

export default json_ld_script_content;
